import * as React from 'react';
import { NavigatorStore } from './stores';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';
import { Navigator } from './Navigator';
import { Admin } from './admin/admin/Admin';
import '../../global';
import { Helper } from '../../Helper';
import { LoggingService } from '../../services/LoggingService';
import { IFontSlots } from '../../interfaces/IFontSlots';
const PACKAGE = require("../../../package.json");

export interface INavigatorProps {
  id: string;
  instance: string;
  instanceId: number;
  tenant: string;
  token: string;
  environment?: "Development" | "Test" | "Production",
  highlightColor: string;
  isAdmin?: boolean;
  loadLinksExternally?: boolean;
  asMobileAppComponent?: boolean;
  isPreview?: boolean;
  fontSlots?: IFontSlots;
  getPageInformation?: () => Promise<{ pageTitle: string, topicHeader: string, textControls: string[] }>;
}
export interface INavigatorState {
  version: string;
}

export class IANavigator extends React.Component<INavigatorProps, INavigatorState> {

  private navigatorStore: NavigatorStore;

  constructor(props: INavigatorProps) {
    super(props);
    this.state = {
      version: Helper.getRandomStringKey()
    }
    let tenant = this.props.tenant;
    if (tenant == undefined) {
      tenant = location.host == "localhost:3000" ? "intraactivedev.sharepoint.com" : location.host;
    }
    this.navigatorStore = new NavigatorStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.navigatorStore.id = props.id;
    this.navigatorStore.environment = props.environment;
    this.navigatorStore.tenant = tenant;
    this.navigatorStore.token = props.token;
    this.navigatorStore.instance = props.instance;
    this.navigatorStore.instanceId = props.instanceId;
    this.navigatorStore.isInEditMode = props.isAdmin;
    this.navigatorStore.highlightColor = props.highlightColor;
    this.navigatorStore.loadLinksExternally = props.loadLinksExternally;
    this.navigatorStore.asMobileAppComponent = props.asMobileAppComponent;
    this.navigatorStore.isAdminPage = props.isAdmin;
    this.navigatorStore.getPageInformation = props.getPageInformation;
    this.navigatorStore.fontSlots = props.fontSlots;

    if (props.asMobileAppComponent) {
      this.navigatorStore.isMobile = true;
    }
    this.navigatorStore.isPreview = props.isPreview;
    if (this.navigatorStore.user == undefined) {
      if (localStorage.getItem("IA-user") != undefined) {
        this.navigatorStore.user = JSON.parse(localStorage.getItem("IA-user"));
      }
    } else if (this.navigatorStore.user != undefined) {
      Helper.setLocalStorage("IA-user", JSON.stringify(this.navigatorStore.user));
    }
    this.navigatorStore.getTargetingApplication();
    LoggingService.init(this.props.environment);
  }

  public registerNavigatedEvent(): void {
    this.navigatorStore.isNavigatedEventRegistered = true;
  }
  public componentDidMount(): void {
    console.log(`%c This IntraActive Navigator is running IntraActive SDK-UI version: ${PACKAGE?.version}`, 'background: #1c899d; color: #ffffff');
  }

  public componentWillReceiveProps(props: INavigatorProps): void {
    this.navigatorStore.highlightColor = props.highlightColor;
    this.navigatorStore.loadLinksExternally = props.loadLinksExternally;
    this.navigatorStore.asMobileAppComponent = props.asMobileAppComponent;
    this.navigatorStore.isPreview = props.isPreview;
    this.navigatorStore.isAdminPage = props.isAdmin;
    this.navigatorStore.fontSlots = props.fontSlots;
    if (this.navigatorStore.instance == undefined || this.navigatorStore.instance != undefined && this.navigatorStore.instance != props.instance) {
      this.navigatorStore.instance = props.instance;
      this.navigatorStore.instanceId = props.instanceId;
      this.navigatorStore.navigatorClicks = undefined;
      this.setState({ version: Helper.getRandomStringKey() });
    }
  }

  render() {
    return (
      <Provider navigatorStore={this.navigatorStore}>
        <>
          <Navigator
            version={this.state.version}
          />
          {this.props.isAdmin &&
            <Admin
              version={this.state.version}
            />
          }
        </>
      </Provider>
    )
  }
}
